// extracted by mini-css-extract-plugin
module.exports =  {"faq-icon":"_7a3fb80146--faq-icon--pN1rz","tooltip":"_7a3fb80146--tooltip--gS7mP"};